import { render, staticRenderFns } from "./_cv-accordion-item-skeleton.vue?vue&type=template&id=01d99ac4&"
import script from "./_cv-accordion-item-skeleton.vue?vue&type=script&lang=js&"
export * from "./_cv-accordion-item-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports